import React, { useState } from "react";
import ParagraphTag from "../../reusebale/Paragraph";
import ButtonTag from '../../reusebale/button';
import BaseUrl from "../../../constants/BaseUrl";
import MyLoader from "../../reusebale/MyLoader";
import SuccessPopup from "../../popup/success"
import RejectLandlordPopup from "../../popup/RejectLandlord"
import {useSelector} from 'react-redux'
const Approval = ({ selectedLandlord, onClose }) => {

  const [loading, setLoading] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false);
  const [showReject, setShowReject] = useState(false);
  const [rejectReson, setRejectReson] = useState("")

  const openPopup = () => {
    setShowSuccess(true);
  };
    const { loginSuccess, } = useSelector(
      (state) => state.auth
    );
  const DecisionHadnler = (status) => {
    setLoading(true)
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      "recordId": selectedLandlord._id,
      "status": status
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${BaseUrl}landlord/profile/landlordProfileDecision`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          setLoading(false)
          setShowSuccess(true)


        } else {
          setLoading(false)
          alert(result.message)
        }
      })
      .catch((error) => console.error(error));
  }

  const closePopup = () => {
    setShowSuccess(false);
    onClose();
  };

  const closeReasonPopup = () => {
    setShowReject(false);
    onClose();
  };

  const LandlorProfileReject = () => {
    setLoading(true)
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      "recordId": selectedLandlord._id,
      "status": "rejected",
      "isReject": true,
      "rejectReson": rejectReson
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${BaseUrl}landlord/profile/landlordProfileDecision`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          setShowReject(false)
          setLoading(false)
          setShowSuccess(true)

        } else {
          setShowReject(false)
          setLoading(false)
          alert(result.message)
        }
      })
      .catch((error) => console.error(error));
  }


  const AllowChangesProfile = () => {
    setLoading(true)
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      "recordId": selectedLandlord._id,
      "status": "save",

    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${BaseUrl}landlord/profile/landlordProfileDecision`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          setShowReject(false)
          setLoading(false)
          setShowSuccess(true)

        } else {
          setShowReject(false)
          setLoading(false)
          alert(result.message)
        }
      })
      .catch((error) => console.error(error));
  }
  return (
    <div className="bg-white rounded-xl mt-3">
      <div className="py-4 flex flex-col items-center justify-center">
        <div className="text-center">
          <ParagraphTag
            content="Landlord Profile Decisions"
            classes="text-darkColor font-popinsSemiBold text-lg"
          />
          <ParagraphTag
            content="After your decision, the landlord can log in and perform their operations."
            classes="text-darkColor font-popinsRegular mt-[-2px] text-[11px] "
          />
        </div>
        {
          loading ? <div className="p-12">
            <MyLoader />

          </div> : <div className="w-[40%] justify-center items-center flex">
            <div className="w-[100%] px-2">
              <ButtonTag onSubmit={() => {
                DecisionHadnler("accepted")
              }} name='Approve' classes='text-xs bg-themeColor hover:bg-themeColor/90 mt-3 text-center text-white' />
            </div>

            {
              !selectedLandlord?.approved && selectedLandlord?.approvedStatus === "appeal" && <div className="w-[100%] px-2">
                <ButtonTag onSubmit={AllowChangesProfile} name='Allow Changes' classes='text-xs bg-error hover:bg-error/90 mt-2 text-center text-white' />
              </div>
            }

            {
              !selectedLandlord?.approved && selectedLandlord?.approvedStatus == "sendForApproval" && <div className="w-[100%] px-2">
                <ButtonTag onSubmit={() => { setShowReject(true) }} name='Reject' classes='text-xs bg-error hover:bg-error/90 mt-2 text-center text-white' />
              </div>
            }


          </div>
        }


      </div>
      {showSuccess && <SuccessPopup onClose={closePopup} isShowDesc={false}/>}
      {showReject && <RejectLandlordPopup
        onResonChange={(e) => {
          setRejectReson(e.target.value)
        }}
        onBack={() => {
          setShowReject(false)
        }}
        onReasonSubmit={LandlorProfileReject} />}
    </div>
  );
};

export default Approval;
